const PlusRoundOutlined = ({ size = 16 }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={size}
    height={size}
    fill='none'
    viewBox='0 0 16 17'
  >
    <path
      fill='#06F'
      d='M8 .5a8 8 0 1 0 8 8 8.01 8.01 0 0 0-8-8m0 14.667A6.666 6.666 0 1 1 14.667 8.5 6.674 6.674 0 0 1 8 15.167M11.333 8.5a.667.667 0 0 1-.666.667h-2v2a.667.667 0 0 1-1.334 0v-2h-2a.667.667 0 0 1 0-1.334h2v-2a.667.667 0 0 1 1.334 0v2h2a.667.667 0 0 1 .666.667'
    />
  </svg>
);

export default PlusRoundOutlined;
